export type Game = {
    id: string;
    name: string;
    homeTeamId: string;
    awayTeamId: string;
    homeScore: number;
    awayScore: number;
    gameName: string;
    status: GameStatus;
    period: number;
    clock: number;
    startDate: string;
    homeStarterId1: string;
    homeStarterId2: string;
    homeStarterId3: string;
    homeStarterId4: string;
    homeStarterId5: string;
    awayStarterId1: string;
    awayStarterId2: string;
    awayStarterId3: string;
    awayStarterId4: string;
    awayStarterId5: string;
    homeParticipants: string[];
    awayParticipants: string[];
}

export enum GameStatus {
    STATUS_HALFTIME = "STATUS_HALFTIME",
    STATUS_IN_PROGRESS = "STATUS_IN_PROGRESS",
    STATUS_SCHEDULED = "STATUS_SCHEDULED",
    STATUS_FINAL = "STATUS_FINAL",
}

export function getStatusDisplay(status: GameStatus): string {
    switch (status) {
        case GameStatus.STATUS_SCHEDULED:
            return 'Scheduled';
        case GameStatus.STATUS_IN_PROGRESS:
            return 'Live';
        case GameStatus.STATUS_HALFTIME:
            return 'Halftime';
        case GameStatus.STATUS_FINAL:
            return 'Final';
        default:
            return status;
    }
}

export function getStatusClass(status: GameStatus): string {
    switch (status) {
        case GameStatus.STATUS_IN_PROGRESS:
        case GameStatus.STATUS_HALFTIME:
            return 'status-live';
        case GameStatus.STATUS_FINAL:
            return 'status-final';
        case GameStatus.STATUS_SCHEDULED:
            return 'status-scheduled';
        default:
            return '';
    }
}

export type PaginatedGames = {
    games: Game[];
    totalCount: number;
    page: number;
    pageSize: number;
    totalPages: number;
}
